import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import LocationApi from "../../api/location";
import useCallApi from "../../hooks/useCallApi";
import { Routes } from "../../routes/Routes";
import { useAlert } from "../../context/AlertContext";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";

const useLocationsContainer = (gameId: any) => {
  const navigate = useNavigate();
  const { callApi, loading } = useCallApi();
  const { setSuccessMessage } = useAlert();
  const { isRTL } = useRTL();

  const { locations } = useContent().pages;

  const [pageLoading, setPageLoading] = useState(true);

  const [allLocations, setAllLocations] = useState([]);

  const [selected, setSelected] = useState<any>(null);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(6);

  const handleChangePage = (
    location: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    setPageLoading(true);
    callApi(LocationApi.getAll(gameId), (locations: any) => {
      setAllLocations(locations);
      setPageLoading(false);
    });
  }, [isRTL]);

  const handleOpenDelete = (row: any) => {
    setSelected(row);
    setOpenDeleteDialog(true);
  };

  const handleDelete = () => {
    callApi(LocationApi.delete(selected.id), () => {
      setAllLocations(
        allLocations.filter((location: any) => location.id !== selected.id)
      );
      setSelected(null);
      setOpenDeleteDialog(false);
      setSuccessMessage(locations.deleteLocation);
    });
  };

  const handleEdit = (id: string) => {
    navigate(Routes.getEditLocation(gameId, id));
  };

  return {
    locations: allLocations,
    pageLoading,
    page,
    handleChangePage,
    rowsPerPage,
    handleOpenDelete,
    handleDelete,
    handleEdit,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  };
};

export default useLocationsContainer;
